import AppServices from "./appservices";

class ConfigService extends AppServices {

  getConfig() {
    return this.request("/chatConfig", "GET");
  }
}

export default ConfigService;